module.exports = __webpack_public_path__ + "img/icon5.d9f2e72a.svg";